<div class="header-wrapper row m-0 font-OpenSans">
    <app-search></app-search>
    <div class="header-logo-wrapper col-auto p-0">
        <app-header-logo [icon]="'align-center'" [type]="'header'"></app-header-logo>
    </div>

    <div class="left-header col-xxl-6 col-xl-8 col-lg-7 col-md-8 col-sm-3 p-0">
        <!-- <app-header-notice></app-header-notice> -->
           <h3 class="d-flex dark-header fw-bold">{{ orgName }}</h3>
    </div>
  

    <div class="nav-right col-xxl-6 col-xl-4 col-md-4 col-8 pull-right right-header p-0 ms-auto">
        <ul class="nav-menus">

            <!-- <li class="language-nav" (click)="toggleLanguage()">
                <app-header-language></app-header-language>
            </li> -->

               <li *ngIf="simulationEnabled">
                <button
                    type="button"
                    class="btn btn-sm rounded header-simulation-btn btn-primary"
                    (click)="goToSimulation()"
                    title="Simulation Active"
                >
                    <i class="bi bi-cpu me-1"></i>
                    Simulation
                    <span class="header-simulation-dot header-simulation-dot--on"></span>
                </button>
            </li>

            <li class="fullscreen-body">
                <app-toggle-screen></app-toggle-screen>
            </li>

         

            <!-- <li>
                <app-svg-icon [icon]="'search'" (click)="openSearch()"></app-svg-icon>
            </li>

            <li class="onhover-dropdown">
                <app-header-bookmark></app-header-bookmark>
            </li> -->

            <li>
                <app-mode></app-mode>
            </li>

            <!-- <li class="onhover-dropdown">
                <app-header-notification></app-header-notification>
            </li> -->

            <li class="profile-nav onhover-dropdown pe-0 py-0">
                <app-profile></app-profile>
            </li>
        </ul>
    </div>
</div>